import React, { useState, useEffect } from "react";
import "./styles/global.css";
import "./styles/userManagement.css";
import "./App.css";
import Sidebar from "./component/Sidebar";
import Header from "./component/Header";
import DashboardPage from "./pages/DashboardPage.jsx";
import SchoolsPage from "./pages/SchoolPage.jsx";
import TeachersPage from "./pages/TeachersPage.jsx";
import StudentsPage from "./pages/StudentsPage.jsx";
import ExamsPage from "./pages/ExamPage.jsx";
import BookMasterPage from "./pages/BookMasterPage.jsx";
import BooksPage from "./pages/BooksPurchasePage.jsx";
import FeesPage from "./pages/FeesPage.jsx";
import CentersPage from "./pages/CentersPage.jsx";
import ReportsPage from "./pages/ReportsPage";
import SettingsPage from "./pages/SettingsPage";
import LoginPage from "./pages/LoginPage.jsx";


import UserListPage from "./pages/UserListPage.jsx";
import UserRoleListPage from "./pages/UserRoleListPage.jsx";
import UserRoleMappingPage from "./pages/UserRoleMappingPage.jsx";
import MenuListPage from "./pages/MenuListPage.jsx";
import MenuRoleMappingPage from "./pages/MenuRoleMappingPage.jsx";

/* ============================= */

import SettingsPanel from "./component/SettingsPanel";
import ProfilePanel from "./component/ProfilePanel";

import SchoolForm from "./component/SchoolForm.jsx";
import StudentForm from "./component/StudentForm.jsx";
import TermsAndConditionsPage from "./pages/policies/TermsAndConditions.jsx";
import PrivacyPolicyPage from "./pages/policies/PrivacyPolicy.jsx";
import ShippingAndDeliveryPolicyPage from "./pages/policies/ShippingAndDeliveryPolicy.jsx";
import CancellationAndRefundPolicyPage from "./pages/policies/CancellationAndRefundPolicy.jsx";
import MyExamPage from "./pages/MyExamPage.jsx";
import StudentBookAssign from "./pages/StudentBookAssignPage.jsx";



function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return sessionStorage.getItem("isLoggedIn") === "true";
  });

  const [isRegistering, setIsRegistering] = useState(false);

  const handleRegister = () => {
    console.log("Register Now clicked");
    setIsRegistering(true);
  };

  const storedUser = JSON.parse(
    sessionStorage.getItem("user") || "{}"
  );

  const studentId = Number(
    sessionStorage.getItem("studentId") ??
    storedUser?.studentId ??
    storedUser?.StudentId ??
    0
  );

  const teacherId = Number(
    sessionStorage.getItem("teacherId") ??
    storedUser?.teacherId ??
    storedUser?.TeacherId ??
    0
  );

  const roleName =
    studentId > 0
      ? "Student"
      : teacherId > 0
        ? "Teacher"
        : (
          storedUser?.roleName ??
          storedUser?.RoleName ??
          sessionStorage.getItem("roleName") ??
          ""
        );

  const normalizedRole = String(roleName)
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

  const isAdmin =
    normalizedRole === "admin" ||
    normalizedRole === "superadmin";

  const [page, setPage] = useState(() => {
    const savedPage =
      localStorage.getItem("activePage");

    if (studentId > 0) {
      return savedPage === "exams"
        ? savedPage
        : "exams";
    }

    return savedPage || "dashboard";
  });
  const [schools, setSchools] = useState([]);
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [exams, setExams] = useState([]);
  const [books, setBooks] = useState([]);
  const [fees, setFees] = useState([]);
  const [centers, setCenters] = useState([]);

  const [overlay, setOverlay] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);


  useEffect(() => {
    localStorage.setItem("activePage", page);
  }, [page]);



  const handleNav = (id) => {
    setPage(id);
    setOverlay("");
    setSidebarOpen(false);
  };


  const toast = (msg) => {

    alert(msg);

  };

  // ======================================================
  // PUBLIC REGISTRATION
  // ======================================================

  if (isRegistering) {
    return (
      <div className="min-h-screen w-full bg-slate-50 px-4 py-8">
        <div className="w-full max-w-6xl mx-auto">
          <StudentForm
            publicRegistration={true}
            onRegistrationComplete={() => {
              setIsRegistering(false);
              setIsLoggedIn(false);
            }}
            onBack={() => {
              setIsRegistering(false);
            }}
          />
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <LoginPage
        onLogin={(loginUser) => {
          const user =
            loginUser ||
            JSON.parse(
              sessionStorage.getItem("user") ||
              "{}"
            );

          const loggedStudentId = Number(
            user?.studentId ??
            user?.StudentId ??
            sessionStorage.getItem("studentId") ??
            0
          );

          const defaultPage =
            loggedStudentId > 0
              ? "exams"
              : "dashboard";

          setPage(defaultPage);

          localStorage.setItem(
            "activePage",
            defaultPage
          );

          setOverlay("");
          setIsLoggedIn(true);
        }}
        onRegister={handleRegister}
      />
    );
  }

  if (!isLoggedIn) {
    return (
      <LoginPage
        onLogin={() => {
          setPage("dashboard");
          localStorage.setItem("activePage", "dashboard");
          setOverlay("");
          setIsLoggedIn(true);
        }}
      />
    );
  }


  return (

    <div className="layout">


      {/* ============================= */}
      {/* SIDEBAR */}
      {/* ============================= */}

      <Sidebar
        page={page}
        handleNav={handleNav}
        setOverlay={setOverlay}
        isOpen={sidebarOpen}
      />

      {sidebarOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Close sidebar"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div className="main">
        <Header
          page={page}
          overlay={overlay}
          setOverlay={setOverlay}
          sidebarOpen={sidebarOpen}
          onMenuToggle={() =>
            setSidebarOpen((prev) => !prev)
          }
        />


        <div className="cnt">


          {/* ====================================================== */}
          {/* USER MANAGEMENT */}
          {/* ====================================================== */}


          {/* USER LIST */}

          {page === "user-list" && (

            <UserListPage />

          )}


          {/* USER ROLE LIST */}

          {page === "user-role-list" && (

            <UserRoleListPage />

          )}


          {/* USER ROLE MAPPING LIST */}

          {page === "user-role-mapping" && (

            <UserRoleMappingPage />

          )}


          {/* MENU LIST */}

          {page === "menu-list" && (

            <MenuListPage />

          )}


          {/* MENU ROLE MAPPING LIST */}

          {page === "menu-role-mapping" && (

            <MenuRoleMappingPage />

          )}



          {/* ====================================================== */}
          {/* EXISTING DASHBOARD */}
          {/* ====================================================== */}

          {page === "dashboard" && (

            <DashboardPage
              onNav={handleNav}
              schools={schools}
              exams={exams}
            />

          )}



          {/* ====================================================== */}
          {/* SCHOOLS */}
          {/* ====================================================== */}

          {page === "schools" && (

            <SchoolsPage
              schools={schools}
              setSchools={setSchools}
              students={students}
              setStudents={setStudents}
              toast={toast}
            />

          )}



          {/* ====================================================== */}
          {/* TEACHERS */}
          {/* ====================================================== */}

          {page === "teachers" && (

            <TeachersPage
              teachers={teachers}
              setTeachers={setTeachers}
              schools={schools}
              students={students}
              toast={toast}
            />

          )}



          {/* ====================================================== */}
          {/* STUDENTS */}
          {/* ====================================================== */}

          {page === "students" && (

            <StudentsPage
              students={students}
              setStudents={setStudents}
              schools={schools}
              toast={toast}
            />

          )}



          {/* ====================================================== */}
          {/* EXAMS */}
          {/* ====================================================== */}

          {page === "exams" && (

            <ExamsPage
              exams={exams}
              setExams={setExams}
              teachers={teachers}
              centers={centers}
              toast={toast}
            />

          )}



          {/* ====================================================== */}
          {/* MY EXAMS - STUDENT */}
          {/* ====================================================== */}

          {page === "my-exams" && (
            <MyExamPage />
          )}

          {page === "book-master" && (
            <BookMasterPage
              books={books}
              setBooks={setBooks}
              toast={toast}
            />
          )}



          {page === "books" && (

            <BooksPage
              books={books}
              setBooks={setBooks}
              schools={schools}
              toast={toast}
            />

          )}



          {/* ====================================================== */}
          {/* FEES */}
          {/* ====================================================== */}

          {page === "fees" && (

            <FeesPage
              fees={fees}
              schools={schools}
              toast={toast}
            />

          )}

          {page === "student-book-assign" && (
            <StudentBookAssign
            />
          )}

          {page === "settings" && (

            <SettingsPage />

          )}



          {/* ====================================================== */}
          {/* CENTERS */}
          {/* ====================================================== */}

          {page === "centers" && (

            <CentersPage
              centers={centers}
              setCenters={setCenters}
              toast={toast}
            />

          )}



          {/* ====================================================== */}
          {/* NOTIFICATIONS */}
          {/* ====================================================== */}

          {/* {page === "notifications" && ( 

            <NotificationsPage /> 

          )}  */}





          {/* ====================================================== */}
          {/* REPORTS */}
          {/* ====================================================== */}

          {page === "reports" && (
            <ReportsPage
              schools={schools}
              exams={exams}
            />
          )}
          {page === "report-teacher-wise-book-assign" && (
            <ReportsPage reportType="GetTeacherWiseBookAssignReport" />
          )}

          {page === "report-students" && (
            <ReportsPage reportType="GetAllStudentsReport" />
          )}

          {page === "report-pending-payments" && (
            <ReportsPage reportType="GetAllPendingPaymentsReport" />
          )}

          {page === "report-payments" && (
            <ReportsPage reportType="GetAllPaymentsReport" />
          )}
          {page === "report-student-book-assign" && (
            <ReportsPage reportType="GetStudentBookAssignReport" />
          )}
          {page === "report-district-wise-school" && (
            <ReportsPage reportType="GetDistrictWiseSchoolReport" />
          )}

          {page === "terms-and-conditions" && (
            <TermsAndConditionsPage />
          )}

          {page === "privacy-policy" && (
            <PrivacyPolicyPage />
          )}

          {page === "shipping-and-delivery-policy" && (
            <ShippingAndDeliveryPolicyPage />
          )}

          {page === "cancellation-and-refund-policy" && (
            <CancellationAndRefundPolicyPage />
          )}

        </div>

      </div>

      {overlay === "settings" && (

        <SettingsPanel
          onClose={() => setOverlay("")}
          onNav={(p) => {

            setPage(p);

            setOverlay("");

          }}
        />

      )}

      {overlay === "profile" && (

        <ProfilePanel
          onClose={() => setOverlay("")}
          toast={toast}
        />

      )}


    </div>

  );

}

export default App;
